import React, { useState } from "react";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";
import { Typography } from "@mui/material";
import appcolors from "../../../constants/Colors";
import ServiceModal from "../../../components/serviceModal";

const displayRows = [
  "appointmentId",
  "dateMonth",
  "assingedBranch",
  "user_detaile",
  "appoindment_details",
];

const headerData = [
  {
    id: 1,
    label: "Appointment#Id",
  },
  {
    id: 2,
    label: "Day-Month",
  },
  {
    id: 3,
    label: "Branch-Name",
  },
  {
    id: 3,
    label: "User-Detail",
  },
  {
    id: 4,
    label: "Appointment-Details",
  },
];

function TodaysAppointments({ data }) {
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleViewDetails = (row) => {
    console.log(row, "rowrowrow123123123123");
    setSelectedRow(row);
    setOpen(true);
  };
  return (
    <Template
      primaryHeading={"Today’s next appointments"}
      secondaryHeading={"Latest"}
    >
      {data?.length > 0 ? (
        <DashboardTable
          showHeader={true}
          headerData={headerData}
          tableData={data}
          handleViewDetails={handleViewDetails}
          diplayRows={displayRows}
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
        >
          No Today’s next appointments Found!
        </Typography>
      )}
      <ServiceModal data={selectedRow} open={open} setOpen={setOpen} />
    </Template>
  );
}

export default TodaysAppointments;
